<template>
  <modal-backdrop persist>
    <spinner />
  </modal-backdrop>
</template>

<script setup lang="ts">
import { ModalBackdrop } from '../_components/modal-backdrop';
import { Spinner } from '@/components/base/spinner';
</script>
